import React from "react";
import styled from "styled-components";
import { Button } from "reactstrap";
// import { useThemeContext } from "../../Context/ThemeContext";

const Input = styled.input.attrs((props) => ({
  type: "text",
  size: props.small ? 5 : undefined,
}))`
  height: 32px;
  width: 200px;
  border-radius: 3px;
  border-top-left-radius: 5px;
  border-bottom-left-radius: 5px;
  border-top-right-radius: 0px;
  border-bottom-right-radius: 0px;
  border: 1px solid #e5e5e5;
  padding: 0 32px 0 16px;
`;

const ClearButton = styled(Button)`
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
  border-top-right-radius: 5px;
  border-bottom-right-radius: 5px;
  height: 34px;
  width: 64px;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  color: primary;
`;

const FilterComponent = ({ filterText, onFilter, onClear }) => {
  return (
    <div style={{ border: "1px solid black", borderRadius: "5px", display: "flex", alignItems: "center" }}>
      <Input
        className="bg-transparent w-100"
        id="search"
        type="text"
        placeholder="Search..."
        value={filterText}
        onChange={onFilter}
      />
      <ClearButton type="button" onClick={onClear}>
        clear
      </ClearButton>
    </div>
  );
};

export default FilterComponent;
